/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="86.81"
        height="73.21"
        viewBox="0 0 86.81 73.21"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#0e497b"
          d="M63.53 0C76.4 0 86.81 11.79 86.81 26.22c0 11.38-7.1 22.45-19 32.85a115.67 115.67 0 0 1-13.19 10c-.61.4-1.21.78-1.8 1.15l-1.15.71-1.1.67-.8.47-.51.29-.66.38-.69.38a1.26 1.26 0 0 1-1.18 0l-.87-.48-1-.54-.8-.48-.86-.51c-2.44-1.49-5-3.19-7.69-5.09a89.85 89.85 0 0 1-18.82-17.58 1.26 1.26 0 0 1 2-1.53 87.67 87.67 0 0 0 18.39 17c2.31 1.65 4.58 3.15 6.74 4.49l1.13.69 1.17.7.52.3.75.43.94-.53.51-.3c1.38-.81 2.88-1.74 4.48-2.78a113.4 113.4 0 0 0 12.91-9.74c11.36-10 18.1-20.48 18.1-31 0-13.11-9.36-23.72-20.78-23.72a19.56 19.56 0 0 0-15.21 7.6 1.24 1.24 0 0 1-1.94 0A19.54 19.54 0 0 0 31.22 2.5c-11.42 0-20.78 10.61-20.78 23.72a26.81 26.81 0 0 0 1.44 8.53 1.25 1.25 0 0 1-2.37.79 29.37 29.37 0 0 1-1.57-9.29C7.94 11.82 18.34.03 31.22.03a21.81 21.81 0 0 1 16 7.14l.19.21.2-.21A21.81 21.81 0 0 1 63.15.03Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M35.93 23.44a1.25 1.25 0 0 1 2.3-.13v.13l10.52 28.92 7.18-11.47a1.24 1.24 0 0 1 .92-.57h14a1.25 1.25 0 0 1 .13 2.49H57.69l-8.18 13a1.25 1.25 0 0 1-2.18-.06v-.13L37.11 27.56l-5.14 14.42a1.28 1.28 0 0 1-1 .82H1.25a1.252 1.252 0 0 1-.13-2.5h28.79Z"
          className="icon-fill icon-accent"/>
      </svg>

    );
  }
}

Icon.displayName = 'HeartWithPulseOximeterWaveIcon';

export default Icon;
